import classNames from 'classnames';

import classes from './RedesignContainer.module.scss';

type DivElementProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const RedesignContainer = ({ className, children, ...props }: DivElementProps) => (
  <div className={classNames(classes.container, className)} {...props}>
    <div className={classes.patternImage} />
    {children}
  </div>
);
